<template>
	<header>
		<div class="container-general">
			<div class="container" id="sub">
				<div class="home-link">
					<a :href="quotation_type === 'report-aci' ? '/report' : '/home'" class="logo-container">
						<img title="Quotazione e valutazione auto" class="qr-logo"
							src="../../../images/project-img/logo-dueruote.png" />
					</a>
				</div>
				<div class="login">
					<div class="login-round" v-if="loggedUser">
						<img v-on:click="checkIfLogged" src="../../../images/project-img/motoicon-white.svg" class="propic" />
					</div>

					<svg v-else id="Ico_User_1" data-name="Ico User 1" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
						viewBox="0 0 24 24" v-on:click="checkIfLogged">
						<path id="login-ico"
							d="M177,165a12,12,0,1,0,12,12A12,12,0,0,0,177,165Zm7.5,20.165v-.7c0-6.615-15-6.615-15,0v.7a11.087,11.087,0,1,1,15,0Zm-7.5-16.1a4.565,4.565,0,1,0,4.565,4.565A4.565,4.565,0,0,0,177,169.065Z"
							transform="translate(-165 -165)" fill="#fff" />
					</svg>
					<div id="menu-utente_dropdown" class="menu-utente_dropdown" :class="{ open: isMenuOpen }">
						<div class="arrow-up"></div>
						<span id="icon-Icona_Chiudi" class="icon-Icona_Chiudi" v-on:click="closeMenu"></span>
						<a :href="quattroruoteUrl + '/profilo.html'" class="menu-utente__header" target="_blank" rel="nofollow">
							<img class="userImage zaux-media-item zaux-radius1" src="../../../images/project-img/motoicon.svg"
								title="" alt="" />
							<svg class="default-userImage" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
								style="display: none;">
								<path fill="#D20A11"
									d="M177,165a12,12,0,1,0,12,12A12,12,0,0,0,177,165Zm7.5,20.165v-.7c0-6.615-15-6.615-15,0v.7a11.087,11.087,0,1,1,15,0Zm-7.5-16.1a4.565,4.565,0,1,0,4.565,4.565A4.565,4.565,0,0,0,177,169.067Z"
									transform="translate(-165 -164.997)"></path>
							</svg>
							<div class="utente-header_right">
								<div class="menu-username uppercase">
									{{ loggedUser ? loggedUser.fullname : 'NOME COGNOME' }}
								</div>
								<span>Visualizza Profilo</span>
							</div>
						</a>
						<div class="menu-utente__content">
							<a :href="quattroruoteUrl + '/profilo.html'" class="utente-content_row " target="_blank" rel="nofollow">
								<div class="row_round">
									<span class="menu-utente-settings"></span>
								</div>
								<span class="row_text">Impostazioni e Dati</span>
								<span class="icon-Icona_Arrow_Slider_right"></span>
							</a>

							<a :href="quattroruoteUrl + '/profilo/moto'" class="utente-content_row " target="_blank" rel="nofollow">
								<div class="row_round">
									<span class="menu-utente-no_crash"></span>
								</div>
								<span class="row_text">Moto</span>
								<span class="icon-Icona_Arrow_Slider_right"></span>
							</a>

							<a :href="quattroruoteUrl + '/profilo/le-mie-quotazioni'" class="utente-content_row " target="_blank"
								rel="nofollow">
								<div class="row_round">
									<span class="menu-utente-Raggruppa"></span>
								</div>
								<span class="row_text">Quotazioni</span>
								<span class="icon-Icona_Arrow_Slider_right"></span>
							</a>

							<!-- <a :href="quattroruoteUrl + '/area-personale/servizi/abbonamenti/'" class="utente-content_row "
								target="_blank" rel="nofollow">
								<div class="row_round">
									<span class="menu-utente-fact_check"></span>
								</div>
								<span class="row_text">Abbonamenti</span>
								<span class="icon-Icona_Arrow_Slider_right"></span>
							</a> -->

							<a href="#" class="utente-content_row qrt-trigger-logout-box">
								<div class="row_round">
									<span class="menu-utente-logout"></span>
								</div>
								<span class="row_text" @click="logout">Esci</span>
								<span class="icon-Icona_Arrow_Slider_right"></span>
							</a>
						</div>
						<div class="privacy-links-container">
							<a href="/system/termini-e-condizioni-duso.html" class="utente-privacy" target="_blank">Termini e
								Condizioni d'Uso</a>
							&nbsp;-&nbsp;
							<a href="https://www.edidomus.it/policy/disclaimer.html" class="utente-privacy"
								target="_blank">Privacy</a>
							&nbsp;-&nbsp;
							<a href="https://www.edidomus.it/policy/index.php" class="utente-privacy" target="_blank">Cookie</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</header>
</template>

<script>
export default {
	name: 'HeaderTopBar',
	data() {
		return {
			isMenuOpen: false,
		};
	},
	props: {
		loggedUser: Object,
		quattroruoteUrl: String,
		quotation_type: String,
	},
	methods: {
		checkIfLogged(event) {
			if (!this.loggedUser) window.location.href = '/auth/domus';
			else this.toggleMenu(event);
		},
		logout() {
			window.location.href = '/auth/domus/logout';
		},
		toggleMenu(event) {
			this.isMenuOpen = !this.isMenuOpen;
			event.stopPropagation();
		},
		closeMenu(event) {
			this.isMenuOpen = false;
			event.stopPropagation();
		},
		handleClickOutside(event) {
			if (!this.$el.contains(event.target)) {
				this.isMenuOpen = false;
			}
		},
	},
	mounted() {
		document.addEventListener('click', this.handleClickOutside);
	},
	beforeDestroy() {
		document.removeEventListener('click', this.handleClickOutside);
	},
};
</script>



// WEBPACK FOOTER //
// resources/js/app/components/HeaderTopBar.vue